module.exports = __webpack_public_path__ + "static/media/upload.cba814a7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/upload.svg
// module id = 285
// module chunks = 0